import { ROUTE_PATHS } from 'constants/index'
import Home from 'games/Home'
import { lazy } from 'react'

const DiceGame = lazy(() => import('games/DiceGame/index'))
const CrashGame = lazy(() => import('games/CrashGame'))

const routesList = [
  {
    path: ROUTE_PATHS.home,
    component: Home,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.crashGame,
    component: CrashGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.diceGame,
    component: DiceGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  }
]

export default routesList
